(function () {
  function ready(cb, n) {
    n = n || 0;
    if (window.gsap && window.ScrollTrigger && window.SplitText) return cb();
    if (n > 150) return;
    setTimeout(function () { ready(cb, n + 1); }, 60);
  }
  window.DozzeeMotion = {
    init: function (root, opts) {
      opts = opts || {};
      var S = { alive: true, cleanup: [] };
      ready(function () {
        if (!S.alive || !root) return;
        var gsap = window.gsap, ST = window.ScrollTrigger, Split = window.SplitText;
        gsap.registerPlugin(ST, Split);
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var fonts = document.fonts ? Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 2000); })]) : Promise.resolve();
        fonts.then(function () {
          if (!S.alive) return;
          var lenis = null, raf = null, splits = [], mags = [];
          if (!reduce && window.Lenis && opts.smooth !== false) {
            try {
              lenis = new window.Lenis({ lerp: 0.1, anchors: true });
              lenis.on('scroll', ST.update); window.__dzLenis = lenis;
              raf = function (t) { lenis.raf(t * 1000); };
              gsap.ticker.add(raf); gsap.ticker.lagSmoothing(0);
            } catch (e) { lenis = null; }
          }
          var q = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
          var once = function (el, start) { return { trigger: el, start: start || 'top 88%', once: true }; };
          var ctx = gsap.context(function () {
            q('[data-lines]').forEach(function (el) {
              var sp = Split.create(el, { type: 'lines', mask: 'lines' }); splits.push(sp);
              gsap.from(sp.lines, { yPercent: 105, duration: 1.1, ease: 'expo.out', stagger: 0.09, scrollTrigger: once(el) });
            });
            q('[data-chars]').forEach(function (el) {
              // Arabic letters must stay joined: animate words instead of characters on RTL pages.
              var rtl = getComputedStyle(el).direction === 'rtl';
              var sp = Split.create(el, { type: rtl ? 'lines,words' : 'lines,words,chars', mask: 'lines' }); splits.push(sp);
              gsap.from(rtl ? sp.words : sp.chars, { yPercent: 110, rotation: 8, duration: 1, ease: 'expo.out', stagger: 0.025, scrollTrigger: once(el) });
            });
            q('[data-reveal]').forEach(function (el) { gsap.from(el, { y: 44, opacity: 0, duration: 1.1, ease: 'expo.out', scrollTrigger: once(el, 'top 92%') }); });
            q('[data-stagger]').forEach(function (el) { gsap.from(el.children, { y: 36, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.08, scrollTrigger: once(el, 'top 90%') }); });
            q('[data-reveal-img]').forEach(function (el) {
              gsap.fromTo(el, { clipPath: 'inset(14% 10% 14% 10% round 24px)' }, { clipPath: 'inset(0% 0% 0% 0% round 24px)', duration: 1.4, ease: 'expo.out', scrollTrigger: once(el, 'top 90%') });
              var im = el.querySelector('img'); if (im) gsap.fromTo(im, { scale: 1.25 }, { scale: 1, duration: 1.6, ease: 'expo.out', scrollTrigger: once(el, 'top 90%') });
            });
            q('[data-count]').forEach(function (el) {
              var raw = el.getAttribute('data-count'), end = parseFloat(raw), dec = (raw.split('.')[1] || '').length, o = { v: 0 };
              el.textContent = (0).toFixed(dec);
              gsap.to(o, { v: end, duration: 1.8, ease: 'power3.out', scrollTrigger: once(el, 'top 92%'), onUpdate: function () { el.textContent = o.v.toFixed(dec); } });
            });
            q('[data-par]').forEach(function (el) { var v = +el.getAttribute('data-par'); gsap.fromTo(el, { y: -v }, { y: v, ease: 'none', scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } }); });
            if (!reduce) q('[data-float]').forEach(function (el, k) { gsap.to(el, { y: -14, rotation: -3, duration: 2.4 + k * 0.3, ease: 'sine.inOut', yoyo: true, repeat: -1 }); });
            q('[data-magnetic]').forEach(function (el) {
              var mx = gsap.quickTo(el, 'x', { duration: 0.5, ease: 'power3' }), my = gsap.quickTo(el, 'y', { duration: 0.5, ease: 'power3' });
              var mv = function (e) { var r = el.getBoundingClientRect(); mx((e.clientX - (r.left + r.width / 2)) * 0.3); my((e.clientY - (r.top + r.height / 2)) * 0.4); };
              var lv = function () { mx(0); my(0); };
              el.addEventListener('pointermove', mv); el.addEventListener('pointerleave', lv); mags.push([el, mv, lv]);
            });
            if (opts.extra) opts.extra(gsap, ST, q, Split, splits);
          }, root);
          var rf = setTimeout(function () { ST.refresh(); }, 700);
          S.cleanup.push(function () {
            clearTimeout(rf);
            mags.forEach(function (m) { m[0].removeEventListener('pointermove', m[1]); m[0].removeEventListener('pointerleave', m[2]); });
            ctx.revert();
            splits.forEach(function (s) { try { s.revert(); } catch (e) {} });
            if (raf) gsap.ticker.remove(raf);
            if (lenis) lenis.destroy();
          });
        });
      });
      return function () { S.alive = false; S.cleanup.forEach(function (f) { try { f(); } catch (e) {} }); };
    }
  };
})();
